import React from 'react';

function Button({ onClick, text, className }) {
    return (
        <button
            className={"tc pa2 mh2 mv1 f5 link dim dib white bn " + className }
            onClick={onClick}>{text}</button>
    )
}
Button.defaultProps = { className: "" }

export default Button